import { ACRONYMS } from "@/config/config";
import { Badge, BadgeList, SubList } from "@/store/interface/common";
/** 获取当前公司的徽标 */
export const getBadge = (badges: Badge[], number: string) => badges.find((item: Badge) => number == item.companyNumber);

/** 获取简写 */
export const getType = (name: string) => ACRONYMS.find((arr: string[]) => arr[0] == name);

/** 获取指定list */
export const getCountO = (list: BadgeList[], type: string[]) => list.find((b: BadgeList) => b.moduleType == type[1]);

/** 获取指定list */
export const getSubCount = (list: any, subId: string) => list?.find((b: SubList) => b.subId == subId);
